import axios from "axios";
import store from "~/store";
import app from "../app";
import swal from "sweetalert2";

axios.interceptors.request.use(request => {
  const token = store.getters["auth/token"];

  if (token) {
    //request.headers.common['Authorization'] = `Bearer ${token}`
    request.headers["Authorization"] = `Bearer ${token}`;
  }

  return request;
});

let isRefreshing = false;
let refreshSubscribers = [];

axios.interceptors.response.use(
  response => response,
  async error => {
    const { config, status } = error.response;
    const originalRequest = config;

    if (status === 500) {
      swal({
        title: swal.i18n.t("error_alert_title"),
        text: swal.i18n.t("error_alert_text"),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: "swal-type-error",
        imageUrl: "/img/popup_img_error.png",
        imageHeight: 80,
        imageWidth: 80
      });
    }
    if (status > 500) {
      console.error(error.response.statusText);
    }

    if (status === 401 && store.getters["auth/token"]) {
      // start refresh proc

      if (!isRefreshing) {
        isRefreshing = true;

        axios
          .post("api/v1/refresh")
          .then(res => {
            isRefreshing = false;

            store.dispatch("auth/saveToken", {
              token: res.data.token
            });

            refreshSubscribers.map(cb => cb(res.data.token));
          })
          .catch(async error => {
            await swal({
              title: swal.i18n.t("token_expired_alert_title"),
              text: swal.i18n.t("token_expired_alert_text"),
              showCloseButton: true,
              customClass: "swal-type-warning",
              imageUrl: "/img/popup_img_warning.png",
              imageHeight: 48,
              imageWidth: 48
            });

            await app.$store.dispatch("auth/logout");

            app.$router.push(
              { name: "login" },
              function() {},
              function() {}
            );
            refreshSubscribers = [];
            isRefreshing = false;

            // return Promise.resolve()
          });

        // if (shouldReturn) {
        //     console.log('refreshing failed')
        //     return Promise.reject(error)
        // }
      }

      const retryRequestPromise = new Promise((resolve, reject) => {
        refreshSubscribers.push(token => {
          originalRequest.headers["Authorization"] = "Bearer " + token;

          resolve(axios(originalRequest));
        });
      });

      return retryRequestPromise;
    }

    if (status === 429) {
      swal({
        title: swal.i18n.t("error_429_alert_title"),
        text: swal.i18n.t("error_429_alert_text"),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: "swal-type-error",
        imageUrl: "/img/popup_img_error.png",
        imageHeight: 80,
        imageWidth: 80
      });
    }

    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./resources/js/plugins/axios.js